import * as muiRadioGroup from "@material-ui/core/RadioGroup";
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles,
} from "@material-ui/core/styles";
import * as React from "react";

interface Props extends muiRadioGroup.RadioGroupProps {}

const styles = (theme: Theme) =>
  createStyles({
    root: {},
  });

export class RadioGroup extends React.PureComponent<
  Props & WithStyles<typeof styles>
> {
  public render() {
    const _props = { ...this.props };

    return <muiRadioGroup.default {..._props} />;
  }
}

export default withStyles(styles)(RadioGroup);
